/* Qué significa la respuesta de un DELETE de Supabase.
 *
 * ── UN DELETE BLOQUEADO POR RLS NO FALLA ─────────────────────────────────
 *
 * Y es todo el punto de que esto exista. PostgREST aplica la política como un
 * FILTRO: si la fila no pasa, el `delete` no encuentra nada que borrar y
 * contesta **204 sin error**. Un `if (error) throw` deja pasar eso como
 * éxito — la pantalla dice «listo» y la fila sigue ahí.
 *
 * Es el mismo error que ya nos costó una vuelta con el `fetch` que seguía el
 * redirect al login y traía el HTML con 200: el camino entero «funciona» y lo
 * único que no pasó es lo que se pedía.
 *
 * Por eso la llamada pide `.select()`: así la respuesta trae las filas que SÍ
 * se borraron, y cero es una respuesta —«no te dejo»— y no un silencio.
 *
 * ── «NO PODÉS» Y «NO PUDE» NO SON LO MISMO ───────────────────────────────
 *
 * Tres desenlaces y tres frases, con la misma regla que el borrado de tickets
 * en FlotaBot: un problema del servidor disfrazado de permiso manda a la
 * persona a buscar donde no está, y el arreglo que va a intentar —pedir el
 * permiso— no arregla nada.
 *
 * ── VIVE SUELTO, SIN CLIENTE NI RED ──────────────────────────────────────
 *
 * En su propio archivo y no adentro de `viajes.service`, que arrastra medio
 * hub al importarse (realtime, Scania, cargas). Es la misma separación que
 * `clasificar` al lado de `datos()` en los informes: acá está la decisión que
 * importa y se prueba en una tabla.
 */
export const leerBorrado = ({ data, error } = {}) => {
  // El error gana: con las dos cosas a la vez, lo que hay que decir es lo que
  // se rompió y no una conclusión sacada de una lista que nunca llegó.
  if (error) {
    return {
      ok: false,
      motivo: "fallo",
      mensaje: `No se pudo borrar: ${error.message || "el servidor no contestó"}`,
    };
  }
  if (!data || data.length === 0) {
    return {
      ok: false,
      motivo: "no_autorizado",
      mensaje: "No se borró nada.",
    };
  }
  return { ok: true, cuantas: data.length };
};
